import "bootstrap/dist/css/bootstrap.min.css";
import * as d3 from "d3";
import Navigationbar from "./Navbar";
import Forecast from "./Forecast";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Somaiya from "./Somaiya";
import Card from "react-bootstrap/Card";
import Heatmap from "./GeoMap.js";
import { useEffect, useState } from "react";
import Scope from "./Scope";
import CheckBox from "./Checkbox";
import { Stack, Form } from "react-bootstrap";
import moment from "moment";
import ColorLabel from "./ColorLabel";
import Legend from "./Legend";

function Watch() {
  const [toggleNational, settoggleNational] = useState(true);
  const [regional, setRegional] = useState("north");
  const [forecast, setForecast] = useState(1);
  const [showHeatwave, setshowHeatwave] = useState(true);
  const [data, setData] = useState({});
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [filteredData, setFilteredData] = useState(data);
  const [mapLeadDate, setMapLeadDate] = useState(selectedDate);

  useEffect(() => {
    if (selectedDate) {
      fetch(`https://heatwave.kjsieit.com/api/data?date=${selectedDate}`)
        .then((response) => response.json())
        .then((data) => {
          setData(data);
          setFilteredData(data["day1"]);
        });
    } else {
      fetch(`https://heatwave.kjsieit.com/api/data`)
        .then((response) => response.json())
        .then((data) => {
          setData(data);
          setFilteredData(data["day1"]);
        });
    }
  }, [selectedDate]);

  useEffect(() => {
    if (forecast) {
      setFilteredData(data[`day` + forecast]);
    }
    if (toggleNational === true) {
      setFilteredData(data[`day` + forecast] || filteredData);
    } else {
      console.log(forecast);
      console.log(data[`day` + forecast]);
      setFilteredData(
        data[`day` + forecast].filter((value) => value.Region === regional)
      );
    }
  }, [regional, toggleNational, forecast]);

  return (
    <Container fluid className="Full p-0">
      <div>
        <Navigationbar />
      </div>
      <Container className="Main_Container">
        <Row>
          <Col xs={12} md={12} lg={9} className="Left_section">
            <Container fluid className="Map_Section">
              <Card className="Map_Card">
                <Container className="Mapheader_container mb-4">
                  <Row>
                    <Col className="Maptitle_col">
                      <Card.Title className="Mapheader">
                        <Stack direction="vertical">
                          <div className="Mapheader_title">Heatwave Watch</div>
                          <div>
                            <Stack direction="vertical" gap={2}>
                              <div className="Mapheader_time">
                                <span style={{ color: "#212121" }}>
                                  Forecast Date:
                                </span>{" "}
                                {moment(selectedDate).format("DD-MM-YYYY")}
                              </div>
                              <div className="Mapheader_time">
                                <span style={{ color: "#1497e3" }}>
                                  Forecast Valid for:{" "}
                                  {moment(mapLeadDate).format("DD-MM-YYYY")}
                                </span>
                              </div>
                            </Stack>
                          </div>
                        </Stack>
                      </Card.Title>
                    </Col>
                    <Col md="auto" className="Map_Scope">
                      <div>
                        <Scope
                          setRegional={setRegional}
                          toggleNational={settoggleNational}
                        />
                      </div>
                    </Col>
                  </Row>
                </Container>
                <Card.Body className="p-0 m-0">
                  <Heatmap data={filteredData} showHeatwave={showHeatwave} />
                </Card.Body>
                <Card.Footer className="Disclaimer">
                  This is an experimental research product. Kindly refer{" "}
                  <a href="http://mausam.imd.gov.in">mausam.imd.gov.in</a> for
                  official forecasts.
                  <br /> The displayed map is intended for research purposes
                  only and should not be considered as a political map.
                </Card.Footer>
              </Card>
            </Container>
          </Col>
          <Col xs={12} md={12} lg={3} className="Right_section">
            <Container fluid className="Forecast">
              <Row>
                <Col>
                  <h5>Date</h5>
                </Col>
              </Row>
              <Container className="Forecast_card_body">
                <Row className="mb-2">
                  <div className="Select_Date">
                    <Form.Control
                      className="Date_picker"
                      type="date"
                      name="sd"
                      dateFormat="dd/mm/yyyy"
                      placeholder="Selected Date"
                      defaultValue={selectedDate}
                      max={new Date().toISOString().slice(0, 10)}
                      onChange={(event) => setSelectedDate(event.target.value)}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                  </div>
                </Row>
              </Container>
            </Container>

            <div>
              <Forecast
                setForecast={setForecast}
                fselectedDate={selectedDate}
                setMapLeadDate={setMapLeadDate}
              />
            </div>

            <div>
              <ColorLabel />
            </div>

            <div>
              <Somaiya />
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Watch;
